import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { db } from "../firebase";
import { collection, query, where, getDocs } from "firebase/firestore";

const UserOffersPage = () => {
  const { userId } = useParams();
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchOffers = async () => {
      const offersRef = collection(db, "offers");
      const q = query(offersRef, where("userId", "==", userId));

      try {
        const querySnapshot = await getDocs(q);
        const offersList = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setOffers(offersList);
      } catch (error) {
        setError("فشل في جلب العروض. حاول مرة أخرى.");
      } finally {
        setLoading(false);
      }
    };

    fetchOffers();
  }, [userId]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="text-xl font-semibold text-gray-600">جاري التحميل...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="text-xl font-semibold text-red-600">{error}</div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-center mb-6">العروض التي أنشأها الشريك</h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {offers.length > 0 ? (
          offers.map((offer) => (
            <div
              key={offer.id}
              className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300"
            >
              {/* Image */}
              <img
                src={offer.image}
                alt={offer.name}
                className="w-full h-48 object-cover rounded-md mb-4"
              />
              {/* Offer Details */}
              <h2 className="text-2xl font-semibold text-gray-800">{offer.name}</h2>
              <p className="text-gray-600 mt-2">{offer.description}</p>
              <p className="text-gray-500 mt-2">المدينة: {offer.city}</p>
              <p className="text-gray-500">البلد: {offer.country}</p>
              <p className="text-gray-500">النوع: {offer.type}</p>
              <p className="text-sm text-gray-400 mt-2">
                تم الإنشاء في: {offer.createdAt.toDate().toLocaleDateString()}
              </p>
              <p className="text-xl font-bold text-gray-900 mt-4 mb-4">السعر: ${offer.price}</p>
              <Link
                className="bg-[#1CC752] text-white px-4 py-2 mt-8 rounded-lg hover:bg-[#0B4B41]"
                to={`/OffersPage/${offer.id}`}
              >
                عرض التفاصيل
              </Link>
            </div>
          ))
        ) : (
          <p className="col-span-full text-center text-lg text-gray-600">لم يتم العثور على عروض.</p>
        )}
      </div>
    </div>
  );
};

export default UserOffersPage;
